import React from 'react';
import peaceTechLogo from '../assets/peace-tech-logo.png';
import HoverCelebrationLogo from './HoverCelebrationLogo';
import { isEnglish } from '../i18n/locale';

const CompanyInfo = () => {
  return (
    <div className="company-info">
      <HoverCelebrationLogo
        className="company-logo-image"
        src={peaceTechLogo}
        alt="PeaceTech Logo"
        label={isEnglish ? 'PeaceTech logo: hover, focus or tap to celebrate' : 'PeaceTech 图标：悬停、聚焦或点击，转满一圈后撒花'}
        completeLabel={isEnglish ? 'Ta-da!' : '撒花！'}
      />
      <h1>PeaceTech</h1>
      <p>Making simple and interesting things.</p>
    </div>
  );
};

export default CompanyInfo;
